import { useEffect, useState } from "react"
import { DigitalSignature } from "../../components/DigitalSignature"
import Input from "../../components/Input"
import { ChecklistStyles } from "../../utils/styles"
import { productDetails } from "../../utils/styles"
import { LoadingButton } from "@mui/lab"
import { useLocalStorage } from "../../hooks/useLocalStorage"
import AutocompleteDeluxe from "../../components/AutocompleteDelux"
import { values } from "lodash"
import firmaDefault from "../../images/croquis/firma_default.png"

let vs = ChecklistStyles()
let vs2 = productDetails()
const Firma = ({
  guardar,
  permisoCheck,
  canvasFirma,
  firma,
  setFirma,
  nombre,
  setNombre,
  loadingButton,
  entregado,
  setEntregado
}) => {
  let ChecklistStyles = vs()
  let productDetails = vs2()
  const [permiso] = useLocalStorage("permiso", null)
  const [firmar, setFirmar] = useState(false)
  const [tempImg, setTempImg] = useState(null)

  useEffect(() => {
    if (firma) {
      setTempImg(firma.toDataURL())
    }
  }, [firma])

  return (
    <div
      style={{ display: "flex", flexWrap: "wrap" }}
      className={ChecklistStyles.componentContainer}
    >
      <div className={ChecklistStyles.dateNameContainer}>
        <div className={ChecklistStyles.sizeDataName}>
          <Input
            typeInput={"form"}
            valor={nombre}
            typeFormat="text"
            nombre="Quien recibe"
            setDatos={setNombre}
            placeholder="Quien recibe"
            required="true"
            onChange={(e) => {
              setNombre(e.target.value)
            }}
          />
        </div>
      </div>
      <div className={ChecklistStyles.dateNameContainer}>
        <div className={ChecklistStyles.sizeDataName}>
          <Input
            typeInput={"form"}
            valor={entregado}
            typeFormat="text"
            nombre="Quien entrega"
            setDatos={setEntregado}
            placeholder="Quien entrega"
            required="true"
            onChange={(e) => {
              setEntregado(e.target.value)
            }}
          />
        </div>
      </div>
      <div className={ChecklistStyles.firmaContainer}>
        <>
          {firmar ? (
            <DigitalSignature
              ref={canvasFirma}
              firma={firma}
              setFirma={setFirma}
              setFirmar={setFirmar}
            />
          ) : (
            <img
              onClick={(e) => {
                setFirmar(true)
              }}
              style={{ maxWidth: "100%", height: "100%" }}
              src={
                tempImg
                  ? tempImg
                  : firmaDefault
              }
              alt={"firma del paciente"}
            />
          )}
        </>
      </div>
      <div className={productDetails.buttonAreaEspecial}>
        {(permiso[permisoCheck] & 2) === 2 ? (
          <LoadingButton
            loading={loadingButton}
            onClick={guardar}
            sx={{
              width: "170px",
              height: "50px",
              backgroundColor: "#157CC1",
              fontFamily: "poppins",
              borderRadius: "10px",
              border: "none",
              fontWeight: "500",
              fontSize: "14px",
              letterSpacing: "0.07em",
              color: "#FFFFFF",
              marginLeft: "2px",
              "@media (min-width: 600px)": {
                marginBottom: "6px"
              },
              "&:hover": {
                backgroundColor: "#1565c0",
                cursor: "pointer"
              }
            }}
          >
            GUARDAR
          </LoadingButton>
        ) : (
          <LoadingButton
            onClick={guardar}
            disabled
            sx={{
              width: "170px",
              height: "50px",
              backgroundColor: "#157CC1",
              fontFamily: "poppins",
              borderRadius: "10px",
              border: "none",
              fontWeight: "500",
              fontSize: "14px",
              letterSpacing: "0.07em",
              color: "#FFFFFF",
              marginLeft: "2px",
              "@media (min-width: 600px)": {
                marginBottom: "6px"
              },
              "&:hover": {
                backgroundColor: "#1565c0",
                cursor: "pointer"
              }
            }}
          >
            GUARDAR
          </LoadingButton>
        )}
      </div>
    </div>
  )
}
export default Firma
